import { RESERVE_STATUS_ALL, ReserveStatusKey } from '../../constants';
import { ReserveListOut } from '../../../../store/api';
import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export type ApiReserveReportsParams = {
    financialYear: string | number;
    status: ReserveStatusKey;
};

export const fetchReserveReports = ({ financialYear, status }: ApiReserveReportsParams) => {
    const params = { financialYear };

    if (status !== RESERVE_STATUS_ALL) {
        params['status'] = status;
    }

    return http.get<ReserveListOut[]>(reservesConfig().endpointReserveListOverview, { params }).then(res => res.data);
};
